import { Environments, getEnvironment } from './getEnvironment';

const NAME_PROD_PATTERN = /^[a-zA-ZÀ-ÖØ-öø-ÿ'’\-.\s]*$/;
// Allow numbers for dev purposes
const NAME_STAGING_PATTERN = /^[a-zA-ZÀ-ÖØ-öø-ÿ'’\-.\d\s]*$/;

export const NAME_PATTERN = getEnvironment() === Environments.Production ? NAME_PROD_PATTERN : NAME_STAGING_PATTERN;
